import { Box, Grid, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import config from 'src/config';

import IconTextStyle from './style';

import Image from '@components/atoms/image';

type IconTextProps = {
  icon: string;
  alt: string;
  title: string;
  content: string;
  className?: string;
};

const IconText = ({ icon, alt, title, content, className }: IconTextProps) => {
  const theme = useTheme();

  return (
    <IconTextStyle className={className}>
      <Grid container item xs={12} xl={12} spacing={2}>
        <Grid item xs={3} sm={3} md={12} lg={12} xl={12}>
          <Box className="icon">
            <Image
              alt={alt}
              src={`${config.IMAGE_CDN_HOST}${icon}.png`}
              srcSet={`${config.IMAGE_CDN_HOST}${icon}.png, ${config.IMAGE_CDN_HOST}${icon}@2x.png 2x`}
              srcSetWebp={`${config.IMAGE_CDN_HOST}${icon}.webp, ${config.IMAGE_CDN_HOST}${icon}@2x.webp 2x`}
              className="img"
            />
          </Box>
        </Grid>
        <Grid item xs={9} sm={9} md={12} lg={12} xl={12}>
          <Box className="text">
            <Typography color={theme.palette.textV2.primary} variant="h6_deprecated" component={Box}>
              {title}
            </Typography>
            <Typography color={theme.palette.textV2.secondary} variant="body2_deprecated" fontFamily="lanna">
              {content}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </IconTextStyle>
  );
};

export default IconText;
